import React, { createContext, useContext, useEffect } from 'react';
import { useLocalObservable } from 'mobx-react-lite';
import settingsStore from '@/stores/SettingStore';

const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
  const store = useLocalObservable(() => settingsStore);

  useEffect(() => {
    // Settings decorate the shell, but auth must remain usable on a slow or
    // temporarily unavailable API (especially on mobile networks).
    store.fetchSettings();
  }, [store]);

  return (
    <SettingsContext.Provider value={store}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  const store = useContext(SettingsContext);
  if (!store) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return store;
};
